import { useEffect, useMemo, useState } from "react";
import { formatAmountUnitDecimalPlace } from "@/utility/common";
import { dateFunc } from "@/components/Functions/dateFunc";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
export const useColumnDefs = (caseData: any, writeAcess: boolean) => {
  const { t } = useTranslation();
  const CustomHeader = () => {
    const { defaultUnit } = caseData;
    const [unitName, setUnitName] = useState(defaultUnit?.name);

    useEffect(() => {
      setUnitName(defaultUnit?.name);
    }, [defaultUnit]);

    return `(${unitName})`;
  };

  const AmountCellRenderer = ({
    field,
    params,
  }: {
    field: string;
    params: any;
  }) => {
    const { defaultUnit } = caseData;
    const decimalPlace = useMemo(
      () => defaultUnit?.decimalPlace,
      [defaultUnit]
    );
    const amount = params.data[field];
    const formattedDefaultAmount = formatAmountUnitDecimalPlace(
      amount,
      decimalPlace
    );
    if (
      ["unresolvedCreditorAmount", "unresolvedDebtorAmount"].includes(field)
    ) {
      return (
        <span>
          {formattedDefaultAmount !== "-"
            ? `${formattedDefaultAmount} ${defaultUnit?.name}`
            : formattedDefaultAmount}
        </span>
      );
    } else {
      return (
        <span>
          {formattedDefaultAmount !== "-"
            ? `${formattedDefaultAmount} ${defaultUnit?.name}`
            : formattedDefaultAmount}
        </span>
      );
    }
  };

  return [
    {
      checkboxSelection: writeAcess,
      headerCheckboxSelection: writeAcess,
      headerCheckboxSelectionFilteredOnly: true,
      width: 20,
      suppressSizeToFit: true,
    },
    {
      cellRenderer: "claimCellRenderer",
      field: "claimReferenceId",
      type: "claimReferenceIdType",
      headerName: t("pages.claims.claimsTable.tableColumnsDetails.claimId"),
      cellStyle: {
        cursor: "pointer",
      },
      unSortIcon: true,
      sortable: true,
      comparator: () => 0,
    },
    {
      cellRenderer: "debtorCellRenderer",
      field: "debtorName",
      type: "debtorNameType",
      headerName: t("pages.claims.claimsTable.tableColumnsDetails.debtor"),

      unSortIcon: true,
      sortable: true,
      comparator: () => 0,
    },
    {
      cellRenderer: "creditorCellRenderer",
      field: "creditorName",
      type: "creditorNameType",
      headerName: t("pages.claims.claimsTable.tableColumnsDetails.creditor"),

      unSortIcon: true,
      sortable: true,
      comparator: () => 0,
    },
    {
      field: "assigneeName",
      type: "assigneeNameType",
      headerName: t("pages.claims.claimsTable.tableColumnsDetails.assignee"),

      comparator: () => 0,
      unSortIcon: true,
      sortable: true,
      cellStyle: {
        whiteSpace: "normal",
        lineHeight: "1.5",
      },
      autoHeight: true,
      cellRenderer: function (param: any) {
        return param.data.assigneeName ? (
          <Link
            to={`./creditor/${param.data.assigneeId}`}
            state={{ from: param.data.assigneeId }}
          >
            <span className="text-bold-underline">
              {" "}
              {param.data.assigneeName}{" "}
            </span>
          </Link>
        ) : (
          "-"
        );
      },
    },
    {
      cellRenderer: (params: any) => (
        <AmountCellRenderer field="unresolvedCreditorAmount" params={params} />
      ),
      field: "unresolvedCreditorAmount",
      type: "unresolvedCreditorAmountType",
      unSortIcon: true,
      sortable: true,
      cellStyle: {
        whiteSpace: "normal",
        lineHeight: "1.5",
      },
      comparator: () => 0,
      autoHeight: true,
      headerName: t(
        "pages.claims.claimsTable.tableColumnsDetails.unResolvedCreditorAmount",
        { unitName: CustomHeader() }
      ),
      cellClass: "align-right",
      headerClass: "stepHeaderClass",
    },
    {
      cellRenderer: (params: any) => (
        <AmountCellRenderer field="unresolvedDebtorAmount" params={params} />
      ),
      field: "unresolvedDebtorAmount",
      type: "unresolvedDebtorAmountType",
      unSortIcon: true,
      sortable: true,
      headerName: t(
        "pages.claims.claimsTable.tableColumnsDetails.unResolvedDebtorAmount",
        { unitName: CustomHeader() }
      ),
      comparator: () => 0,
      cellClass: "align-right",
      headerClass: "stepHeaderClass",
    },
    {
      cellRenderer: (params: any) => (
        <AmountCellRenderer field="resolvedAmount" params={params} />
      ),
      field: "resolvedAmount",
      type: "resolvedAmountType",
      unSortIcon: true,
      sortable: true,
      headerName: t(
        "pages.claims.claimsTable.tableColumnsDetails.resolvedAmount",
        { unitName: CustomHeader() }
      ),
      comparator: () => 0,
      cellClass: "align-right",
      headerClass: "stepHeaderClass",
    },
    {
      field: "claimStageName",
      type: "claimStageNameType",
      headerName: t("pages.claims.claimsTable.tableColumnsDetails.stage"),

      unSortIcon: true,
      comparator: () => 0,
    },
    {
      field: "actionStatusName",
      type: "actionStatusNameType",
      headerName: t("pages.claims.claimsTable.tableColumnsDetails.status"),

      unSortIcon: true,
      sortable: true,
      comparator: () => 0,
    },
    {
      field: "updatedOn",
      type: "lastUpdatedDateType",
      headerName: t("pages.claims.claimsTable.tableColumnsDetails.lastUpdated"),
      comparator: () => 0,
      minWidth: 200,
      flex: 1,
      unSortIcon: true,
      sortable: true,
      cellRenderer: function (param: any) {
        return (
          <>
            {dateFunc(param.data.updatedOn).formattedDateTime +
              " " +
              caseData?.abbreviation}
          </>
        );
      },
    },
  ];
};
